'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Number1IconXl } from '@lichtblick/icons/svg/number-1/number-1-xl';
import { Number2IconXl } from '@lichtblick/icons/svg/number-2/number-2-xl';
import { Number3IconXl } from '@lichtblick/icons/svg/number-3/number-3-xl';
import { Number4IconXl } from '@lichtblick/icons/svg/number-4/number-4-xl';
import { Number5IconXl } from '@lichtblick/icons/svg/number-5/number-5-xl';
import { Spacing } from '@lichtblick/theme';
import { Box, Headline } from '@lichtblick/ui-components';
import { useMemo } from 'react';
import { RichText } from '../../../helpers/RichText';
import { getColor } from '../../../utils';
import { AButton } from '../../AButton';
import { Container, Section } from '../shared';
import { Step, Steps } from './Steps';
const icons = [
    Number1IconXl,
    Number2IconXl,
    Number3IconXl,
    Number4IconXl,
    Number5IconXl
];
const titleElementMappers = {
    p: ({ children })=>/*#__PURE__*/ _jsx(Headline, {
            renderAs: "h2",
            size: "M",
            children: children
        })
};
export const FourSteps = ({ button, steps, theme = 'white', title })=>{
    const stepsElementMappers = useMemo(()=>({
            ol: ({ children })=>/*#__PURE__*/ _jsx(Steps, {
                    children: children
                }),
            li: ({ children, i })=>{
                return children && i < icons.length ? /*#__PURE__*/ _jsx(Step, {
                    backgroundColor: theme ? getColor(theme) : undefined,
                    icon: icons[i],
                    text: children
                }) : null;
            }
        }), [
        theme
    ]);
    return /*#__PURE__*/ _jsxs(Section, {
        backgroundColor: theme ? getColor(theme) : undefined,
        children: [
            /*#__PURE__*/ _jsx(Container, {
                $maxWidth: 600,
                textAlign: "center",
                children: title && /*#__PURE__*/ _jsx(RichText, {
                    elementMappers: titleElementMappers,
                    richText: title
                })
            }),
            /*#__PURE__*/ _jsxs(Container, {
                children: [
                    steps && /*#__PURE__*/ _jsx(RichText, {
                        elementMappers: stepsElementMappers,
                        richText: steps
                    }),
                    button?.length === 1 && /*#__PURE__*/ _jsx(Box, {
                        display: "flex",
                        justifyContent: "center",
                        py: Spacing.S,
                        children: /*#__PURE__*/ _jsx(AButton, {
                            ...button[0]
                        })
                    })
                ]
            })
        ]
    });
};

//# sourceMappingURL=FourSteps.js.map